import { FC, ReactNode } from "react";
import { NavLinkProps } from "react-router-dom";

import { NavLink } from "@/components/_molecules/navigation-controls/nav-link";
import { cn } from "@/lib/cn";

interface SidebarNavElementProps extends NavLinkProps {
  children?: ReactNode;
  forceActive?: boolean;
  forceInactive?: boolean;
}

export const SidebarNavElement: FC<SidebarNavElementProps> = ({
  forceActive,
  forceInactive,
  ...props
}: SidebarNavElementProps) => {
  return (
    <NavLink
      {...props}
      className={cn(
        props.className,
        // "block" gives the inline anchor a box the focus outline can be drawn
        // around; the negative offset keeps it inside the sidebar's scroll clip.
        "relative block select-none overflow-visible rounded-md text-sm focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus",
      )}
    >
      {({ isActive }) => (
        <span
          className={[
            "chrome-nav relative flex items-center overflow-hidden text-ellipsis rounded-md pb-0 pl-1.5 pr-0.5 pt-0 hover:bg-foreground/3 hover:text-accent-foreground [&_svg]:text-muted-foreground",
            (isActive || forceActive) && !forceInactive ? "bg-foreground/6 text-accent-foreground" : "",
          ].join(" ")}
        >
          {props.children}
        </span>
      )}
    </NavLink>
  );
};
